// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__PLGXi","inputSearch":"Search_inputSearch__KVbL5"};